// Time before user returns to default page, if screen is left untouched.
export const timeBeforeReturnEvent = 30;
export const milisecondsBeforeReestablishingConnectionToBackendAfterLostConnection = 15000;
